import { Comment, GoogleLocation } from "services/OrderServices";
import { ItemsData } from "shared/constants/ItemConstant";
import {create} from "zustand"
import {persist} from "zustand/middleware"

type AuthModalStore = {
    loginModal: boolean;
    setOffLoginModal:() => void;
    setOnLoginModal:()=> void;

    secureModal: boolean;
    setOffSecureModal:() => void;
    setOnSecureModal:()=> void;

    registerModal: boolean;
    setOffRegisterModal:() => void;
    setOnRegisterModal:()=> void;

    forgotModal: boolean;
    setOffForgotModal:() => void;
    setOnForgotModal:()=> void;

    passwordModal: boolean;
    setOffPasswordModal:() => void;
    setOnPasswordModal:()=> void;

    passwordToken: string;
    setPasswordToken : (passwordToken:string) => void;

    userSub:string;
    setUserSub : (userSub:string) => void;
    

    closeAllModal:()=>void;
}
export const useAuthModalStore = create<AuthModalStore>()(
    (set)=>({
        loginModal: false,
        setOffLoginModal: () =>{
            set({loginModal:false})
        },
        setOnLoginModal: () =>{
            set({loginModal:true})
        },
        secureModal: false,
        setOffSecureModal:() => {set({secureModal:false})},
        setOnSecureModal:()=> {set({secureModal:true})},

        registerModal: false,
        setOffRegisterModal:() => {set({registerModal:false})},
        setOnRegisterModal:()=> {set({registerModal:true})},

        forgotModal: false,
        setOffForgotModal:() => {set({forgotModal:false})},
        setOnForgotModal:()=> {set({forgotModal:true})},

        passwordModal: false,
        setOffPasswordModal:() => {set({passwordModal:false})},
        setOnPasswordModal:()=> {set({passwordModal:true})},

        passwordToken: '',
        setPasswordToken : (passwordToken:string) => {
            set({passwordToken:passwordToken})
        },
        userSub:'',
        setUserSub : (userSub:string) => {
            set({userSub:userSub})
        },

        closeAllModal:()=>{
           set({loginModal:false,secureModal:false,registerModal:false,forgotModal:false})
        }

    })

)

type NewOrderStore = {
    reset:number;
    setReset: () => void;
    /// ORDER TYPE
    orderType: string;
    setOrderType: (orderType:string) => void;
    /// ORDER TYPE
    discountType: string;
    setDiscountType: (discountType:string) => void;
    /// TOTAL PRICE
    totalPrice: number;
    setTotalPrice: (totalPrice:number) => void;
    /// ITEM PRICE / SUBTOTAL
    itemsPrice: number;
    setItemsPrice: (itemsPrice:number) => void;

    /// GST
    orderGST: number;
    setOrderGST: (orderGST:number) => void;

    /// GST
    itemsCost: number;
    setItemsCost: (itemsCost:number) => void;

    /// ORDER ITEMS
    dataSource: Array<ItemsData | undefined>;
    setDataSource: (dataSource:Array<ItemsData | undefined>) => void;

    /// COMMENT
    currentComment:Comment[];
    setCurrentComment: (currentComment:Comment[]) => void;

    /// CUSTOMER REFERENCE
    customerReference: string;
    setCustomerReference: (customerReference:string) => void;

    /// CLEAR NEW ORDER 
    clearNewOrder: () => void;



    /// CUSTOMER INFO
    customerName: string;
    setCustomerName: (customerName:string) => void;
    
    email: string;
    setEmail: (email:string) => void;

    phone: string;
    setPhone: (phone:string) => void;
    currPhone: string;
    setCurrPhone: (currPhone:string) => void;

    company: string;
    setCompany: (company:string) => void;

    shipTo: string;
    setShipTo: (shipTo:string) => void;

    address: string;
    setAddress: (address:string) => void;

    type: string;
    setType: (type:string) => void;

    coordinate: GoogleLocation;
    setCoordinate: (coordinate:GoogleLocation) => void;

    billCoordinate: GoogleLocation;
    setBillCoordinate: (billCoordinate:GoogleLocation) => void;
}


   
export const useNewOrderStore = create<NewOrderStore>()(
    persist(

    (set)=>({
        reset:0,
        setReset: ()=> {
            set({reset:0})
        },
        /// ORDER TYPE
        orderType:'supply_install',
        setOrderType: (orderType:string )=> {
            set({orderType:orderType})
        },
         /// DISCOUNT TYPE
        discountType:'',
        setDiscountType: (discountType:string )=> {
             set({discountType:discountType})
        },
        /// CUSTOMER REFERENCE
        customerReference:'',
        setCustomerReference: (customerReference:string )=> {
             set({customerReference:customerReference})
        },
        /// TOTAL PRICE
        totalPrice:0,
        setTotalPrice: (totalPrice:number )=> {
            set({totalPrice:totalPrice})
        },
        /// ITEM PRICE
        itemsPrice:0,
        setItemsPrice: (itemsPrice:number )=> {
            set({itemsPrice:itemsPrice})
        },
        /// GST
        orderGST:10,
        setOrderGST: (orderGST:number )=> {
            set({orderGST:orderGST})
        },
        /// COST
        itemsCost:0,
        setItemsCost: (itemsCost:number )=> {
            set({itemsCost:itemsCost})
        },
        /// ORDER ITEMS
        dataSource:[],
        setDataSource: (dataSource:Array<ItemsData | undefined> )=> {
            set({dataSource:dataSource})
        },
        /// COMMENT
        currentComment:[],
        setCurrentComment:(currentComment:Comment[])=> {
            set({currentComment:currentComment})
        },
        
        /// CUSTOMER IFO
        customerName:'',
        setCustomerName: (customerName:string)=>{
            set({customerName:customerName})
        },
        email:'',
        setEmail: (email:string)=>{
            set({email:email})
        },
        phone:'',
        setPhone: (phone:string)=>{
            set({phone:phone})
        },
        currPhone:'',
        setCurrPhone: (currPhone:string)=>{
            set({currPhone:currPhone})
        },
        company: '',
        setCompany:  (company:string)=>{
            set({company:company})
        },
    
        shipTo: '',
        setShipTo:  (shipTo:string)=>{
            set({shipTo:shipTo})
        },
    
        address: '',
        setAddress:  (address:string)=>{
            set({address:address})
        },
    
        type: '',
        setType:  (type:string)=>{
            set({type:type})
        },
    
        coordinate: {lat:undefined,lng:undefined} as GoogleLocation,
        setCoordinate: (coordinate:GoogleLocation) =>{
            set({coordinate:coordinate})
        },
    
        billCoordinate: {lat:undefined,lng:undefined} as GoogleLocation,
        setBillCoordinate: (billCoordinate:GoogleLocation) =>{
            set({billCoordinate:billCoordinate})
        },
        /// CLEAR NEW ORDER
        clearNewOrder: () =>{
            set({
                reset:1,
                orderType:'supply_install',
                discountType:'',
                customerReference:'',
                totalPrice:0,
                itemsPrice:0,
                orderGST:10,
                itemsCost:0,
                dataSource:[],
                currentComment:[],
                customerName:'',
                email:'',
                phone:'',
                currPhone:'',
                company: '',
                shipTo: '',
                address: '',
                type: '',
                coordinate: {lat:undefined,lng:undefined} as GoogleLocation,
                billCoordinate: {lat:undefined,lng:undefined} as GoogleLocation,
        
            })
        }
    }),
    {
        name: 'allin1-order-store'
    }
    )

)